function resetHeight() {
    // Reset the body height to that of the inner browser 
    var contentOverMediaElements = document.querySelectorAll(".content-over-media--fill-except-next-section");
    contentOverMediaElements.forEach(function(element) {
        var parent = element.closest("section");
        var sectionHeight = parent.nextElementSibling.offsetHeight;
        element.style.height = "calc(" + window.innerHeight + "px - " + sectionHeight + "px)";
    });
}

document.addEventListener('DOMContentLoaded', function() {
    resetHeight();
    setTimeout(resetHeight, 500);
	
});

// $("[type='submit']").click(function(){
// 	var count = $(".quantity-selector__input").val();
// 	console.log(count)
// 	$("[data-identifier='Antal']").val(count)
//  })